// extracted by css-extract-rspack-plugin
export default {"passwordFormLink":"fSm4p"};